import { z } from "zod";
import { AgendaModuleSchema } from "../../models/agendaModule.schema";

export const PrivateAgendaModuleControllerResponseSchema = {
  listAgendaModules: AgendaModuleSchema.array(),

  getAgendaModule: AgendaModuleSchema.nullable(),

  createAgendaModule: AgendaModuleSchema,

  updateAgendaModule: AgendaModuleSchema,

  deleteAgendaModule: z.void(),
};
